import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import GeneralSkeleton from "@/components/skeleton/general-skeleton";

export default function UISimpleTableSkeleton({ columns }) {
  return (
    <TableBody>
      {[...Array(5)].map((_, index) => (
        <TableRow key={index}>
          {columns.map((_, index) => (
            <TableCell
              key={index}
              align="center"
              sx={{ borderColor: "var(--palette-stroke)" }}
            >
              <GeneralSkeleton sx={{ minWidth: _.width || "100px" }} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}
